import { PEOPLE_SERVICES, PEOPLE_SERVICES_SECTION } from '@/data/people';
import { ServicePackages } from '../service/ServicePackages';

export const PeopleServices = () => (
  <ServicePackages
    services={PEOPLE_SERVICES}
    section={PEOPLE_SERVICES_SECTION}
    accent="#D6318B"
    accentDark="#A01E66"
    accentSoft="#FBDCEE"
    discussHref="/?service=people#solution-finder"
    id="people-services"
    testidPrefix="people"
    layout="grid4"
  />
);
